// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import { useRootModal } from 'hooks/useRootModal';
import React, { useRef, useState } from 'react';
import { EvidenceState } from 'typings';
import { interactiveScale } from 'utilities/FramerAnimations';
import { getSmartImage } from 'utilities/getSmartImage';
import EvidenceModal from '../EvidenceModal/EvidenceModal';
import ImageManager from '../ImageManager/ImageManager';
import Modal from '../Modal/Modal';
import './ImagesUpload.module.scss';
// =========================

export default function ImagesUpload({
  images,
  evidence,
  lesson,
  handleUpload,
  handleDelete,
}: {
  images?: EvidenceState[];
  evidence?: EvidenceEntity[];
  lesson?: LessonEntity;
  handleUpload?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDelete: (c: EvidenceState) => void;
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [evidenceModalIsOpen, setEvidenceModalIsOpen] = useState(false);
  const [initialImage, setInitialImage] = useState<number>(0);

  function handleClick(index: number) {
    setInitialImage(index);
    return images?.length ? setModalIsOpen(true) : setEvidenceModalIsOpen(true);
  }

  const evidenceImages: EvidenceState[] =
    images! ||
    evidence?.map((e) => ({ path: e.path, name: e.name, evidenceId: e.id }))!;

  return (
    <>
      <div styleName={`images-upload ${evidence ? 'evidence' : ''}`}>
        {evidenceImages.map((item, index) => (
          <motion.div
            {...interactiveScale}
            key={index}
            onClick={() => handleClick(index)}
          >
            <img alt="uploads" src={getSmartImage(item.path, item.name)} />
          </motion.div>
        ))}
        {!!handleUpload && (
          <>
            <input
              type="file"
              id={`add-evidence-${lesson?.id}-btn`}
              onChange={handleUpload}
              name="upload"
            />
            <motion.label
              {...interactiveScale}
              htmlFor={`add-evidence-${lesson?.id}-btn`}
            >
              <FontAwesomeIcon icon={faPlus} />
            </motion.label>
          </>
        )}
      </div>
      <AnimatePresence>
        {modalIsOpen && images && (
          <Modal setModalIsOpen={setModalIsOpen} size="medium">
            <ImageManager
              images={images}
              initialImage={initialImage}
              handleDelete={handleDelete}
              setModalIsOpen={setModalIsOpen}
            />
          </Modal>
        )}
        {evidenceModalIsOpen && evidence && (
          <EvidenceModal
            setModalIsOpen={setEvidenceModalIsOpen}
            evidence={evidence}
            handleDelete={handleDelete}
            initialImage={initialImage}
          />
        )}
      </AnimatePresence>
    </>
  );
}
